import React from 'react'
import { Card } from 'react-bootstrap'

const OrderSelectedCard = ({ order }) => {
  const status = order.status
  const statusList = {
    pending: {
      badge: 'badge badge-warning',
      label: 'รอชำระเงิน',
    },
    'receipt attached': {
      badge: 'badge badge-info',
      label: 'แนบสลิปแล้ว',
    },
    success: {
      badge: 'badge badge-success',
      label: 'ซื้อสำเร็จ',
    },
    cancelled: {
      badge: 'badge badge-danger',
      label: 'ยกเลิก',
    },
    processing: {
      badge: 'badge badge-secondary',
      label: 'กำลังดำเนินการจัดส่ง',
    },
    random: {
      badge: 'badge badge-dark',
      label: 'เสื้อกล่องสุ่ม',
    },
  }
  const createdAtDate = new Date(order.createdAt).toLocaleString('TH-th')

  return (
    <Card className=" mb-1" style={{ backgroundColor: '#fff', cursor: 'pointer' }}>
      <Card.Body>
        <div
          className="timeline-panel"
          style={{ display: 'flex', marginBottom: '0px', paddingBottom: '0px', borderBottom: '0px' }}
        >
          <div className="d-flex flex-column flex-grow-1">
            <ul>
              <li className="d-flex justify-content-between align-items-baseline pt-2">
                <div>{`#${order.ref}`}</div>
                <div>
                  {['pending', 'receipt attached', 'success', 'cancelled', 'processing'].indexOf(order.status) >= 0 ? (
                    <span className={statusList[status].badge}>{statusList[status].label}</span>
                  ) : (
                    <span className="badge badge-success">ซื้อสำเร็จ</span>
                  )}
                </div>
              </li>
              <li className="d-flex justify-content-between pt-2">
                <div>{order.shippingAddress.name}</div>
                <div>{order?.userId || order.user?.userId || ''}</div>
              </li>
              <li className="d-flex justify-content-between pt-2">
                <div className="d-flex flex-column text-left">
                  <div>วันที่</div>
                  {createdAtDate}
                </div>
                <div className="d-flex flex-column text-right">
                  <div>ราคา</div>
                  <div>{`${order.totalPrice.toLocaleString()} บาท`}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </Card.Body>
    </Card>
  )
}

export default OrderSelectedCard
